import React from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => {
  return {
    footerActionsBar: { height: 68, background: "white", paddingLeft: "15px", paddingRight: "15px" },
  };
});

function CommandsCard({ buttonLeft, buttonRight }) {
  const classes = useStyles();

  return (
    <Grid container alignItems="center">
      <Grid
        item
        container
        xs={12}
        justifyContent="space-between"
        alignItems="center"
        className={classes.footerActionsBar}
      >
        <Grid item>{buttonLeft}</Grid>
        <Grid item>{buttonRight}</Grid>
      </Grid>
    </Grid>
  );
}

CommandsCard.propTypes = {
  buttonLeft: PropTypes.object,
  buttonRight: PropTypes.object,
};

export default CommandsCard;
